import React__default, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Context } from './Context.js';
import { translations } from './translations.js';

const mergeTranslations = (oldTranslations, newTranslations) => ({
  en: {
    ...oldTranslations.en,
    ...(newTranslations === null || newTranslations === void 0 ? void 0 : newTranslations.en)
  },
  fi: {
    ...oldTranslations.fi,
    ...(newTranslations === null || newTranslations === void 0 ? void 0 : newTranslations.fi)
  },
  sv: {
    ...oldTranslations.sv,
    ...(newTranslations === null || newTranslations === void 0 ? void 0 : newTranslations.sv)
  }
});
const Provider = _ref => {
  let {
    children,
    locale = 'fi',
    translations: translationsFromUser
  } = _ref;
  const mergedTranslations = useMemo(() => mergeTranslations(translations, translationsFromUser), [translationsFromUser]);
  return /*#__PURE__*/React__default.createElement(Context.Provider, {
    value: {
      locale,
      translations: mergedTranslations
    }
  }, children);
};
Provider.displayName = 'Provider';
Provider.propTypes = {
  children: PropTypes.node,
  locale: PropTypes.oneOf(['en', 'fi', 'sv']),
  translations: PropTypes.shape({
    en: PropTypes.objectOf(PropTypes.string),
    fi: PropTypes.objectOf(PropTypes.string),
    sv: PropTypes.objectOf(PropTypes.string)
  })
};

export { Provider };
